module.exports = __webpack_public_path__ + "img/mgm_768_2024.6325754e.jpg";